import React, { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import LocationIcon from '@mui/icons-material/PinDrop';
import CloseIcon from '@mui/icons-material/Close';
import setUserRealm from 'redux/actions/userRealm';
import Styles from 'global/styles';
import { Access } from 'global/components/droprealms';
import { getFirstKey } from 'global/utils';
import { get, set } from 'global/lib/lodash';
import { getRealmIcon } from 'global/components/droprealms';
import { NavLocationButton, NavLocationIcon, NavResetButton, NavRealmModal } from './NavBar/NavBar.styles';
import { Row } from 'global/components/row';

export const REALM_ADD_LISTENERS = 'REALM_ADD_LISTENERS';
export const APP_ACTIONS = 'APP_ACTIONS';
window[REALM_ADD_LISTENERS] = {};
window[APP_ACTIONS] = {};

export default function NavRealm(props) {
  const styles = Styles();
  const access = useRef();

  const realm = useSelector((state) => state.auth.realm);
  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setRealmDialog({
      ...realmDialog,
      open: true,
      buttons: [{ title: 'RESET', onClick: () => handleReset() }],
    });
  };

  const handleReset = (clear = false) => {
    if (clear) {
      dispatch(setUserRealm(null));
      setRealmDialog({
        ...realmDialog,
        buttons: [{ title: 'RESET', onClick: () => handleReset() }],
      });
    }
    get(access, 'current.reset', () => 0)();
  };

  const setNativeRealm = (r) => {
    try {
      get(window, 'TLM.setNativeRealm', () => 0)(r);
    } catch (err) {
      console.warn(err);
    }
  };

  const closeDialog = (value) => {
    if ((value && value.id) || value === 0) {
      dispatch(setUserRealm(value));
    }
    setNativeRealm(value);
    setRealmDialog({
      ...realmDialog,
      open: false,
    });
  };

  const onEditSuccess = (e) => {
    try {
      const listeners = window[REALM_ADD_LISTENERS] || {};
      Object.keys(listeners).map((k) => listeners[k](e));
    } catch (err) {
      console.warn(err);
    }
  };

  const [realmDialog, setRealmDialog] = useState({
    open: false,
    title: 'Set Location',
    keepMounted: true,
    maxWidth: "800px",
    onClose: () => setRealmDialog({ ...realmDialog, open: false }),
    dialogActions: {
      style: { justifyContent: 'flex-start' },
    },
  });

  set(window, [APP_ACTIONS, 'setRealm'], (r) => {
    try {
      dispatch(setUserRealm(r));
    } catch (err) {
      console.error(err);
    }
  });

  const showCloseRealm = get(props, 'showCloseRealm', true);

  return (
    <Row>
      {props.renderButton ? props.renderButton({ onClick: handleClickOpen }) : <NavLocationButton variant="contained" color="primary" data-testid={"navbar-button-location-set"} disableElevation onClick={handleClickOpen}>
        <span>{realm ? realm.name : <em>set location</em>}</span>
        <NavLocationIcon>{realm ? getRealmIcon(realm) : <LocationIcon />}</NavLocationIcon>
      </NavLocationButton>}

      {realm && showCloseRealm && (
        <NavResetButton variant="contained" color="primary" aria-label="reset location" data-testid={"navbar-button-location-reset"} onClick={() => handleReset(true)}>
          <CloseIcon />
        </NavResetButton>
      )}

      <NavRealmModal {...realmDialog} fullHeight={true}>
        <div className={styles.formContainer}>
          <Access
            ref={access}
            openToSelected={true}
            canAdd
            open={get(realmDialog, 'open')}
            currentRealm={realm}
            singleSelect={true}
            onSelectedChange={(s) => closeDialog(getFirstKey(s))}
            onEditSuccess={onEditSuccess}
          />
        </div>
      </NavRealmModal>
    </Row>
  );
}
